"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisibilityUtilities = getVisibilityUtilities;
exports.default = void 0;
var _visibility = require("@bootstrap-styled/css-mixins/lib/visibility");
function getVisibilityUtilities() {
  return "\n    .visible {\n      ".concat((0, _visibility.invisible)('visible'), "\n    }\n    \n    .invisible {\n      ").concat((0, _visibility.invisible)('hidden'), "\n    }\n   \n  ");
}
var _default = {
  getVisibilityUtilities: getVisibilityUtilities
};
exports.default = _default;